module.exports = __webpack_public_path__ + "img/laboratory_01.78d4b32a.png";